import { api } from './client';

export interface ProblemStatement {
  id: string;
  session_id: string;
  topic: string;
  statement: string;
  intro: string;
  ctr: number | null;
  priority: number | null;
  validated: number;
  selected: number;
  review_status: number;
  created_at: string;
  updated_at: string;
  // Joined from campaigns (if available)
  campaign_id?: string;
  campaign_status?: string;
  impressions?: number;
  clicks?: number;
  spend?: number;
  campaign_ctr?: number;
}

export async function listProblemStatements(
  sessionId: string
): Promise<ProblemStatement[]> {
  return api.get(`/problem-statements?session_id=${sessionId}`);
}

export async function getProblemStatement(id: string): Promise<ProblemStatement> {
  return api.get(`/problem-statements/${id}`);
}

export async function createProblemStatement(data: {
  session_id: string;
  topic: string;
  statement: string;
  intro?: string;
}): Promise<ProblemStatement> {
  return api.post('/problem-statements', data);
}

export async function updateProblemStatement(
  id: string,
  data: Partial<Pick<ProblemStatement, 'topic' | 'statement' | 'intro' | 'priority' | 'validated' | 'selected' | 'review_status'>>
): Promise<ProblemStatement> {
  return api.put(`/problem-statements/${id}`, data);
}

export async function deleteProblemStatement(id: string): Promise<void> {
  return api.delete(`/problem-statements/${id}`);
}

export async function bulkImportAI(data: {
  session_id: string;
  prompt?: string;
  count?: number;
}): Promise<{ imported: number; items: ProblemStatement[] }> {
  return api.post('/problem-statements/bulk-import-ai', data);
}
